import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { FileText } from 'lucide-react'
import styled from 'styled-components'
import { colors } from '../../const'
import {
  Card,
  CardContent,
  IconWrapper,
  Title,
  Description,
  ActionButton
} from './styles'

const CardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const NotificationDot = styled.span`
  position: absolute;
  top: 18px;
  right: 18px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${colors.error};
  box-shadow: 0 0 0 4px rgb(239 68 68 / 0.18);
`

const PendingTitle = styled(Title)`
  line-height: 1.25;
  max-width: 18rem;
  margin-left: auto;
  margin-right: auto;
`

const PendingDescription = styled(Description)`
  max-width: 18rem;
`

const DEFAULT_DESCRIPTION = 'Revisar y reportar estudios pendientes de informe'
const EMPTY_TITLE = 'Sin estudios para informar'
const EMPTY_DESCRIPTION = 'No hay estudios pendientes para que informes'

export function OphthalmologistPendingCard ({
  pendingCount = 0,
  loading = false,
  path = '/pending-reports'
}) {
  const history = useHistory()
  const hasPendingStudies = pendingCount > 0
  const isButtonDisabled = loading || !hasPendingStudies

  const title = loading
    ? 'Informar Estudios Pendientes'
    : hasPendingStudies
      ? `Informar Estudios Pendientes (${pendingCount})`
      : EMPTY_TITLE

  const description = loading
    ? DEFAULT_DESCRIPTION
    : hasPendingStudies
      ? DEFAULT_DESCRIPTION
      : EMPTY_DESCRIPTION

  const buttonText = loading
    ? 'Cargando...'
    : hasPendingStudies
      ? 'Informar estudios'
      : 'No hay estudios para informar'

  const handleClick = () => {
    if (!isButtonDisabled) {
      history.push(path)
    }
  }

  return (
    <CardWrapper>
      {hasPendingStudies && !loading && <NotificationDot aria-hidden='true' />}
      <Card>
        <CardContent>
          <IconWrapper>
            <FileText className='w-5 h-5' />
          </IconWrapper>
          <PendingTitle>{title}</PendingTitle>
          <PendingDescription>{description}</PendingDescription>
          <ActionButton onClick={handleClick} disabled={isButtonDisabled}>
            {buttonText}
          </ActionButton>
        </CardContent>
      </Card>
    </CardWrapper>
  )
}

export default OphthalmologistPendingCard
